var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOriginal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1904.94 972.72",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Add Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1_0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_105553277974112"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1555.85 193.37l-59.12 0c-35.03,0 -63.44,27.78 -63.44,62.06l0 75.56 0 168.34 0 0 0 216.87c0,34.28 28.41,62.06 63.44,62.06l59.12 0c35,0 63.34,-27.78 63.44,-62l0 -216.87 0 -168.4 0 -75.56c-0.03,-34.28 -28.44,-62.06 -63.44,-62.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1841.97 389.46l-59.94 0c-34.78,0 -63,-28.22 -63,-63l0 -115.03c0,-34.81 28.22,-63 63,-63l59.94 0c34.78,0 62.96,28.22 62.96,63l0 115.03c0.03,34.78 -28.18,63 -62.96,63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M122.93 389.46l-59.93 0c-34.78,0 -63,-28.22 -63,-63l0 -115.03c0,-34.81 28.22,-63 63,-63l59.93 0c34.78,0 63,28.22 63,63l0 115.03c0,34.78 -28.22,63 -63,63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1276.89 0l-72.71 0c-31.28,0 -56.66,25.06 -56.66,55.97l0 257.24 0 0 0 156.43 0 447.02c0,30.91 25.38,55.97 56.66,55.97l72.71 0.03c31.28,0 56.63,-25 56.63,-55.94l0 -446.98 0 -156.53 0 0 0 -257.24c0,-30.91 -25.35,-55.97 -56.63,-55.97l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M415.99 0l-72.72 0c-31.28,0 -56.66,20.09 -56.66,44.78l0 653.23 0 35.44c0,24.78 25.38,44.81 56.66,44.81l72.72 0c31.28,0 56.62,-20.03 56.62,-44.75l0 -35.44 0 -653.29c0,-24.75 -25.34,-44.78 -56.62,-44.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M573.32 716.26c0,34.28 28.44,62.06 63.44,62.06l59.12 0c35,0 63.44,-27.78 63.44,-62.06l0 -410.74 0 -50.09c0,-34.28 -28.44,-62.06 -63.44,-62.06l-59.12 0c-35.09,0 -63.44,27.78 -63.44,62.06l0 50.09 0 410.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M860.03 654.73l0 262.03c0,30.9 25.35,55.96 56.63,55.96l72.71 0c31.28,0 56.66,-25.06 56.66,-55.96l0 -262.03 0 0 0 -502.8 0 -95.96c0,-30.91 -25.38,-55.97 -56.66,-55.97l-72.71 0c-31.28,0 -56.63,25.06 -56.63,55.97l0 95.96 0 502.8 0 0z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOriginal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/original.9dbbe446.svg";
export { ForwardRef as ReactComponent };